import { render, staticRenderFns } from "./ButtonWidget.vue?vue&type=template&id=dde3c820&scoped=true"
import script from "./ButtonWidget.vue?vue&type=script&lang=js"
export * from "./ButtonWidget.vue?vue&type=script&lang=js"
import style0 from "./ButtonWidget.vue?vue&type=style&index=0&id=dde3c820&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde3c820",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dde3c820')) {
      api.createRecord('dde3c820', component.options)
    } else {
      api.reload('dde3c820', component.options)
    }
    module.hot.accept("./ButtonWidget.vue?vue&type=template&id=dde3c820&scoped=true", function () {
      api.rerender('dde3c820', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layoutDesigner/designer/widgets/ButtonWidget.vue"
export default component.exports